import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  badges?: ReactNode[];
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  subtitle,
  badges = [],
  actions,
  className = ""
}: PageHeaderProps) {
  return (
    <div className={`mb-6 ${className}`} data-testid="page-header">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 min-w-0">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2.5 mb-1 flex-wrap min-w-0">
            <h1
              className="text-xl font-semibold text-gray-900 dark:text-gray-100 truncate"
              title={title}
            >
              {title}
            </h1>
            {badges.map((badge, index) => (
              <div key={index}>{badge}</div>
            ))}
          </div>
          {subtitle && (
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {subtitle}
            </p>
          )}
        </div>
        {actions && <div className="flex-shrink-0">{actions}</div>}
      </div>
    </div>
  );
}